// ************** 在线备课讲义  ****************

// 获取课件详情 actions
export const HANDOUT_GET_DETAIL = 'HANDOUT_GET_DETAIL';

// 新增课件，获取标准教件 actions
export const HANDOUT_ADD_STANDARD_COURSEWARE = 'HANDOUT_ADD_STANDARD_COURSEWARE';

// 初始课件详情 mutations
export const HANDOUT_SET_DETAIL = 'HANDOUT_SET_DETAIL';

// 同步课节名称修改， mutations
export const HANDOUT_SYNC_SESSION_NAME = 'HANDOUT_SYNC_SESSION_NAME';

// 操作问题，移动问题 向上，向下 mutations
export const HANDOUT_MOVE_QUESTION = 'HANDOUT_MOVE_QUESTION';
// 操作问题，删除问题 mutations
export const HANDOUT_DELETE_QUESTION = 'HANDOUT_DELETE_QUESTION';
// 换组问题
export const HANDOUT_TURN_QUESTION = 'HANDOUT_TURN_QUESTION';
// 添加讲法
export const HANDOUT_ADD_CATEGORY = 'HANDOUT_ADD_CATEGORY';

// **************  添加习题(知识库相关)  ****************

// 将所选问题添加到试题篮中 mutations
export const HANDOUT_KB_IN_BASKET = 'HANDOUT_KB_IN_BASKET';
export const HANDOUT_KB_OUT_BASKET = 'HANDOUT_KB_OUT_BASKET';

// 删除指定的题目
export const HANDOUT_SET_DELETECHECKQUES = 'HANDOUT_SET_DELETECHECKQUES';

// 删除全部题目
export const HANDOUT_SET_DELETEALL = 'HANDOUT_SET_DELETEALL';

// 删除题目后的len
export const HANDOUT_SET_DELETEALL_LEN = 'HANDOUT_SET_DELETEALL_LEN';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_handout.js